module.exports = __webpack_public_path__ + "img/201-martinique.97dfaf62.svg";